import styled from "styled-components";
import React, {Component} from "react";
import {withStyles} from "@material-ui/core";

const Button = styled.div`
  display: block;
  position: fixed;
  border-radius: 0.2em;
  right: 0em;
  top: 6em;
  margin: 10px 10px 0;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  margin: 10px 10px 0;
  background-color: white;
  cursor: pointer;
    @media only screen and (max-width: 660px) {
    top: 13em;
  }
`;

const ButtonGeoloc = styled.div`
  background: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' fill='%23333'%3E %3Cpath d='M10 4C9 4 9 5 9 5L9 5.1A5 5 0 0 0 5.1 9L5 9C5 9 4 9 4 10 4 11 5 11 5 11L5.1 11A5 5 0 0 0 9 14.9L9 15C9 15 9 16 10 16 11 16 11 15 11 15L11 14.9A5 5 0 0 0 14.9 11L15 11C15 11 16 11 16 10 16 9 15 9 15 9L14.9 9A5 5 0 0 0 11 5.1L11 5C11 5 11 4 10 4zM10 6.5A3.5 3.5 0 0 1 13.5 10 3.5 3.5 0 0 1 10 13.5 3.5 3.5 0 0 1 6.5 10 3.5 3.5 0 0 1 10 6.5zM10 8.3A1.8 1.8 0 0 0 8.3 10 1.8 1.8 0 0 0 10 11.8 1.8 1.8 0 0 0 11.8 10 1.8 1.8 0 0 0 10 8.3z'/%3E %3C/svg%3E");
  width: 30px;
  height: 30px;
  background-size: 30px;
`;

const styles = theme => ({
    anim: {
        color: 'red',

    },
});

class CelesteGeolocateControl extends Component {

    constructor(props)
    {
        super(props);

        this.state = {
            anim: false
        };
    }

    handleClick = () => {

        this.setState({
            anim: true
        });

        return this.props.geolocateUser();
    };

    render() {
        return (
            <Button onClick={this.handleClick}><ButtonGeoloc className={this.state.anim ? this.props.classes.anim : null}/></Button>
        );
    }
}

export default withStyles(styles)(CelesteGeolocateControl);
